import React from 'react';

const EyeIcon = () =>
  (<svg
    className="icon-wrap"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="21px"
    height="13px"
  >
    <path fillRule="evenodd" fill="rgb(127, 145, 168)" d="M10.500,-0.000 C5.920,-0.000 1.951,2.641 -0.000,6.500 C1.951,10.359 5.920,13.000 10.500,13.000 C15.079,13.000 19.049,10.359 21.000,6.500 C19.049,2.641 15.079,-0.000 10.500,-0.000 L10.500,-0.000 ZM15.677,3.447 C16.911,4.226 17.956,5.271 18.742,6.500 C17.956,7.729 16.911,8.773 15.677,9.553 C14.127,10.532 12.337,11.050 10.500,11.050 C8.663,11.050 6.873,10.532 5.323,9.553 C4.089,8.773 3.043,7.729 2.258,6.500 C3.043,5.270 4.089,4.226 5.323,3.447 C5.403,3.396 5.484,3.347 5.566,3.299 C5.362,3.854 5.250,4.453 5.250,5.078 C5.250,7.950 7.600,10.278 10.500,10.278 C13.399,10.278 15.750,7.950 15.750,5.078 C15.750,4.453 15.638,3.854 15.434,3.299 C15.515,3.347 15.597,3.396 15.677,3.447 L15.677,3.447 Z" />
  </svg>);

export default EyeIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/EyeIcon.js